export enum TranslateEvents {
  TRANSLATED = "translated",
}

export enum TranslateUIEventTypes {
  TRANSLATE = "translate",
  RATE = "rate",
}
